import { render } from "./ComponentCalendarAdmin.vue?vue&type=template&id=23fa4c5e&scoped=true"
import script from "./ComponentCalendarAdmin.vue?vue&type=script&lang=js"
export * from "./ComponentCalendarAdmin.vue?vue&type=script&lang=js"

import "./ComponentCalendarAdmin.vue?vue&type=style&index=0&id=23fa4c5e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23fa4c5e"]])

export default __exports__